var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('h1',[_vm._v(_vm._s(_vm.$tc('message.home.menu.tasas.titulo', 2)))]),_c('div',[_c('CardList',{attrs:{"cards":_vm.opciones}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }